<template>
    <div id="page-name" data-name="contacts">
      <!--Page Header-->
      <section class="page_header padding">
        <div class="container">
          <div class="header_content padding">
            <div class="row">
              <div class="col-md-12 text-center">
                <h1 class="uppercase" style="font-size:50px">Наши контакты</h1>
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="page_menu">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h3 class="hidden">hidden</h3>
              <ul class="breadcrumb">
                <li><a href="/">Главная</a>
                </li>
                <li class="active">Контакты</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!--Contact Us-->
      <section id="contact" class="padding_top">
        <div class="container">
          <div class="row">
            <div class="col-md-8">
              <h3 class="uppercase heading bottom30">отправить обращение</h3>
              <form class="contact-form padding_bottom">
                <div class="row">
                  <div class="col-md-6 form-group">
                    <label for="exampleInputName2">Имя<span style="color:red;font-size:larger">*</span></label>
                    <input type="text" class="form-control" id="exampleInputName2" placeholder="Введите Ваше имя" v-model="feedbackName">
                  </div>
                  <div class="col-md-6 form-group">
                    <label for="exampleInputEmail2">E-Mail<span style="color:red;font-size:larger">*</span></label>
                    <input type="email" class="form-control" id="exampleInputEmail2" placeholder="Введите Ваш E-Mail" v-model="feedbackEmail">
                  </div>
                  <div class="col-md-12 form-group">
                    <label for="messageArea">Сообщение<span style="color:red;font-size:larger">*</span></label>
                    <textarea id="messageArea" class="form-control" placeholder="Сообщение" v-model="feedbackMessage"></textarea>
                    <div style="padding-top: 30px">
                      <img :src="captchaUrl" style="border: 1px solid #30ade7;border-style:dashed;border-radius:3px">
                      <i class="fa fa-refresh"
                         style="color:#30ade7;font-size:28px;padding:10px;top:6px;position:relative;cursor:pointer"
                         @click="reloadCaptcha"
                      ></i>
                      <input type="text" class="" v-model="captchaCode" placeholder="Введите код с картинки">
                    </div>
                    <input type="button" class="btn-form uppercase border-radius margintop40" value="Отправить" @click.prevent="send">
                  </div>
                </div>
              </form>
            </div>

            <div class="col-md-4">
              <div class="contact_detail padding_bottom">
                <h3 class="uppercase heading bottom30">Контакты</h3>
                <p class="bottom30">Направляйте Ваши вопросы и предложения.</p>
                <div class="address bottom30">
                  <i class="fa fa-map-marker"></i>
                  <h5 class="uppercase">Наш Адрес</h5>
                  <p>г. Самара, ул. Советской Армии 181 (рядом Парк Гагарина)</p>
                </div>
                <div class="address bottom30">
                  <i class="fa  fa-phone"></i>
                  <h5 class="uppercase">Телефон</h5>
                  <p><a href="tel:8 (846) 267-51-11">8 (846) 267-51-11</a></p>
                </div>
                <div class="address bottom30">
                  <i class="fa  fa-phone"></i>
                  <h5 class="uppercase">Сотовый</h5>
                  <p><a href="tel:8 917-107-51-11">8 917-107-51-11</a></p>
                </div>
                <div class="address">
                  <i class="fa fa-envelope-o"></i>
                  <h5 class="uppercase">Электронный адрес</h5>
                  <p>E-Mail: <a href="#.">info@oknaogon.ru</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="padding_bottom">
        <yandex-map :coords="coords"
                    :settings="settings"
                    ymap-class="okna-y-map-container"
                    :scroll-zoom="false"
                    map-type="map"
        >
          <ymap-marker
                  marker-id="123"
                  :coords="coords"
          />
        </yandex-map>
      </section>

      <alert :visibility="alertShow" :message="alertMessage" @closeDialog="closeDialog"/>

    </div>
</template>

<script>
  import { yandexMap, ymapMarker } from 'vue-yandex-maps'
  import Alert from './modals/Alert.vue'
  export default {
    components: { yandexMap, ymapMarker, Alert },
    name: "Contacts",
    data () {
      return {
        alertShow: false,
        alertMessage: '',
        feedbackName:'',
        feedbackEmail:'',
        feedbackMessage:'',
        captchaUrl: process.env.VUE_APP_POINT_API + '/captcha',
        formidentyfic:'',
        captchaCode:'',
        settings : {
          apiKey: '741784b1-efdc-40fb-96d5-5d07a1d6b4c5',
          lang: 'ru_RU',
          coordorder: 'latlong',
          version: '2.1'
        },
        coords:[53.224158, 50.200571],
        // ymapClass: "okna-y-map-container",
      }
    },
    created() {
      this.formidentyfic = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 12)
      this.reloadCaptcha()
    },
    methods: {
      reloadCaptcha() {
        // обновляем капчу на сервере
        this.axios.get(process.env.VUE_APP_POINT_API + '/captcha?refresh=true&formidentyfic='+this.formidentyfic)
        .then((res) => {
          // подгружаем ее как картинку
          this.captchaUrl = process.env.VUE_APP_POINT_API + res.data.url + '&formidentyfic=' +this.formidentyfic
        })
      },
      checkRequired() {
        return !(!this.feedbackName || !this.feedbackEmail || !this.feedbackMessage);
      },
      clearFormAndReloadCaptcha() {
        this.feedbackName = ''
        this.feedbackEmail = ''
        this.feedbackMessage = ''
        this.captchaCode = ''
        this.reloadCaptcha();
      },
      send() {
        if (!this.checkRequired()) {
          this.alertMessage = "Все поля формы обязательны для заполнения!"
          this.alertShow = true
          return
        }
        if (!this.captchaCode) {
          this.alertMessage = "Введите код проверки Капчи!"
          this.alertShow = true
          return
        }

        // проверяем капчу на сервере
        this.axios.get(process.env.VUE_APP_POINT_API + '/captcha?validateval='+this.captchaCode+'&formidentyfic='+this.formidentyfic)
        .then((res) => {
          // отправляем форму обратной связи
          if (!res.data.isvalid) {
            this.alertMessage = "Неверно введен код Капчи!"
            this.alertShow = true
            this.captchaCode = ''
            this.reloadCaptcha()
            return
          }
          this.axios.post(
            process.env.VUE_APP_POINT_API + '/feedback',
            {name:this.feedbackName, email:this.feedbackEmail, message:this.feedbackMessage},
          )
          .then(() => {
            this.alertMessage = "Ваше сообщение успешно отправлено менеджеру портала!"
            this.alertShow = true
            this.clearFormAndReloadCaptcha()
            window.dataLayer.push({'event': 'send-order-form'})
          })
          .catch(() => {
            this.alertMessage = "К сожалению возникла непредвиденная ошибка! Попробуйте отправить сообщение позже! Спасибо за понимание!"
            this.alertShow = true
            this.clearFormAndReloadCaptcha();
          })
        })
        .catch(() => {
          this.alertMessage = "К сожалению возникла непредвиденная ошибка! Попробуйте отправить сообщение позже! Спасибо за понимание!"
          this.alertShow = true
          this.clearFormAndReloadCaptcha();
        })

      },
      closeDialog() {
        this.alertShow = false
      }
    }
  }
</script>

<style>
  .okna-y-map-container {
    height: 50vh;
  }
</style>
